import React, { PropsWithChildren } from 'react';

import { IInteractionLoginContext, InteractionLoginContext } from './InteractionLoginContext';

export interface IInteractionLoginContextProviderProps {
  value: IInteractionLoginContext;
}

/**
 * Provide values for the context.
 */
export function InteractionLoginContextProvider({
  value,
  children,
}: PropsWithChildren<IInteractionLoginContextProviderProps>) {
  return (
    <InteractionLoginContext.Provider value={value}>{children}</InteractionLoginContext.Provider>
  );
}
